module.exports = __webpack_public_path__ + "img/header-weddingRingstrisets@2x.16cc979.webp";